import React, { useState, useEffect } from "react";
import { Nav, Navbar } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import logo from "../Images/logo.jpeg";
import "../Css/Home.css";
import { NavLink } from "react-router-dom";
import backgroundImage from "../Images/bacg.png";

const Dashboard = () => {
  const[isSticky, setSticky] =useState(false);
  const sectionStyle = {
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    color: "white", // Text color for better visibility
    padding: "0.11em", // Adjust padding as needed
  };
  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 100) {
        setSticky(true);
      } else {
        setSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <Navbar
      
        collapseOnSelect
        expand="lg"
        className={isSticky ?"contact-section sticky":"contact-section"}
        style={sectionStyle}
      >
        <img
          className="rounded-circle border border-light m-2"
          src={logo}
          height="50"
          width="50"
        />
        <Navbar.Brand className="text-light m-2">Patent-Hub.</Navbar.Brand>
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          style={{ background: "#ff0000", marginRight: "10px", float: "right" }}
        />
        <Navbar.Collapse
          id="responsive-navbar-nav"
          className="justify-content-end"
        >
          <Nav className="mr-auto">
            <NavLink to="/dash-home" className=" m-2" id="nav-dropdown-title">
              <label>Home</label>
            </NavLink>
            <NavLink to="/dash-about" className=" m-2" id="nav-dropdown-title">
              <label>About</label>
            </NavLink>
            <NavLink to="/dash-patent" className=" m-2" id="nav-dropdown-title">
              <label>Patent</label>
            </NavLink>

            <NavLink to="/register" className=" m-2" id="nav-dropdown-title">
              <label>Registration</label>
            </NavLink>
            <NavLink to="/" className=" m-2" id="nav-dropdown-title">
              <label>Log Out</label>
            </NavLink>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </>
  );
};

export default Dashboard;
